{
  "en": {
    "answers": [],
    "tags": [
      {
        "id": 22080,
        "name": "Evaluation"
      },
      {
        "id": 39610,
        "name": "Wordcloud"
      },
      {
        "id": 156068,
        "name": "Sample Question"
      },
      {
        "id": 156083,
        "name": "Survey Question"
      }
    ],
    "text": "Which three words best describe your mood after the course?",
    "is_poll_question": true,
    "type": 3,
    "created_at": "2025-09-02T17:27:20.000Z",
    "created_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "updated_at": "2025-09-03T08:56:26.000Z",
    "updated_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "max_num_characters": 30,
    "max_answer_submissions": 3,
    "explanation": "### Participants can enter short terms as their answers.\n\nThe responses are visualized in a **word cloud**, where frequently mentioned terms appear more prominently. This format is particularly suitable for capturing **moods, impressions, or keywords** spontaneously and creatively.",
    "has_explanation": true,
    "media": {
      "id": 15743,
      "uuid": "4dbd1f90-0bf0-11ed-9983-c151dfdf57d3",
      "file_ext": "jpeg",
      "url": "https://s3.eu-central-1.amazonaws.com/media.quizacademy.io/4dbd1f90-0bf0-11ed-9983-c151dfdf57d3.jpeg"
    },
    "num_answers": 0
  },
  "de": {
    "answers": [],
    "tags": [
      {
        "id": 9427,
        "name": "Musterfrage"
      },
      {
        "id": 14279,
        "name": "Umfragen/Evaluationen"
      }
    ],
    "text": "Welche drei Worte beschreiben Deine Stimmung nach dem Kurs am besten?",
    "is_poll_question": true,
    "type": 3,
    "created_at": "2025-09-03T08:00:33.000Z",
    "created_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "updated_at": "2025-09-03T08:41:21.000Z",
    "updated_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "max_num_characters": 30,
    "max_answer_submissions": 3,
    "explanation": "### Als Antwort können kurze Begriffe eingegeben werden.\n\nDie Rückmeldungen werden in einer **Wordcloud visualisiert**, sodass häufig genannte Begriffe hervorgehoben sichtbar sind. Dieses Format eignet sich besonders, um **Stimmungen, Eindrücke oder Schlagworte** spontan und kreativ zu erfassen.",
    "has_explanation": true,
    "media": {
      "id": 15743,
      "uuid": "4dbd1f90-0bf0-11ed-9983-c151dfdf57d3",
      "file_ext": "jpeg",
      "url": "https://s3.eu-central-1.amazonaws.com/media.quizacademy.io/4dbd1f90-0bf0-11ed-9983-c151dfdf57d3.jpeg"
    },
    "num_answers": 0
  }
}
